import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { BotTab } from './BotTab';
import { WhatsAppTab } from './WhatsAppTab';
import { MessengerTab } from './MessengerTab';
import type { TabId, ChatSettings } from './chat.types';

const TAB_LABELS: Record<TabId, string> = {
  bot: '🤖 Ask Bot',
  whatsapp: '💬 WhatsApp',
  messenger: '📘 Messenger',
};

interface ChatPanelProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  settings: ChatSettings;
}

export function ChatPanel({ activeTab, onTabChange, settings }: ChatPanelProps) {
  const visibleTabs = settings.enabled_tabs;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 16, scale: 0.97 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="absolute bottom-16 right-0 w-[380px] h-[520px] bg-white rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.18)] flex flex-col overflow-hidden"
    >
      {/* Header */}
      <div className="bg-[#E8A838] px-4 py-3 shrink-0">
        <p className="font-semibold text-white text-sm">Protein Meals Support</p>
        <p className="text-amber-100 text-xs">Typically replies within minutes</p>
      </div>

      {/* Tab bar */}
      {visibleTabs.length > 1 && (
        <div className="flex border-b border-gray-100 shrink-0">
          {visibleTabs.map(tab => (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              className={cn(
                'flex-1 py-2.5 text-xs font-medium transition-colors',
                activeTab === tab
                  ? 'text-[#E8A838] border-b-2 border-[#E8A838]'
                  : 'text-gray-500 hover:text-gray-700',
              )}
            >
              {TAB_LABELS[tab]}
            </button>
          ))}
        </div>
      )}

      {/* Tab content */}
      <div className="flex-1 min-h-0">
        {activeTab === 'bot' && <BotTab onSwitchTab={onTabChange} />}
        {activeTab === 'whatsapp' && <WhatsAppTab settings={settings} />}
        {activeTab === 'messenger' && <MessengerTab settings={settings} />}
      </div>
    </motion.div>
  );
}
